import React, { Children, useState } from "react";
import TextField from "@mui/material/TextField";

// import JS files
import MuiTheme from "./MuiTheme";

// import Others files

const MuiTextField = ({
  id,
  label,
  variant,
  size,
  onChange,
  value,
  isLTR,
  type,
  disabled,
  defaultValue,
  placeholder,
  color,
  autoFocus,
  tabIndex,
  onKeyDown
}) => {
  let windowWidth = window.screen.width;
  const ltrStyle = {
    direction: "ltr",
    border: color,
    borderRadius: "0.5rem",
  };
  const rtlStyle = {
    direction: "rtl",
    border: color,
    borderRadius: "0.5rem",
  };
  return (
    <>
      <MuiTheme>
        <TextField
          autoFocus={autoFocus}
          inputProps={{ tabIndex: tabIndex }}
          id={id}
          label={label}
          variant={variant}
          style={isLTR ? ltrStyle : rtlStyle}
          sx={{ width: "100%", input: { textAlign: "center" } }}
          size={size}
          value={value}
          onChange={onChange}
          type={type}
          disabled={disabled}
          defaultValue={defaultValue}
          placeholder={placeholder}
          onKeyDown={onKeyDown}
        />
      </MuiTheme>
    </>
  );
};

export default MuiTextField;
